export default "__VITE_ASSET__4hSvkCcu__"